<template>
    <!-- HEADER-->

    <header class="header-admin">
        <nav class="navbar navbar-expand-md navbar-light bg-white ">
            <div class="container-fluid">


                <button type="button" id="sidebarCollapse" @click="sidebarClicked" class="btn btn-info">
                    <span class="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                </button>
                    <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                    </button>

                <div class="page-title"><h1 >{{getPageHeaderTitle()}}</h1></div>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <!-- Left Side Of Navbar -->
                    <ul class="navbar-nav mr-auto">

                    </ul>

                    <!-- Right Side Of Navbar -->

                </div>
                <div class="ms-auto">
                <nav class="navbar navbar-expand-sm">
                  <!-- Brand -->

                  <!-- Links -->
                  <ul class="navbar-nav">

                    <li class="nav-item btn-group notification">
                      <a class="nav-link dropdown-toggle" href="" id="navbardrop" data-toggle="dropdown">
                      <i class="fas fa-bell"></i>
                      </a>
                      <div class="dropdown-menu">
                        <div class="notification-con">
                            <div class="notification-header">
                            <h3>Notifications</h3>
                                <a v-if="notification_count > 0" href="javascript:void(0)" class="markbtn" @click="dismissAllNotification">Dismiss all</a>
                            </div>
                            <div class="notification-cont">
                                <ul v-if="notifications">
                                    <li v-for="(notification, index) in notifications" :key="'notification_key_' + index">
                                        <router-link :to="{ name: 'viewQuote', params: { id: notification.quote_id }}">
                                            <h4>{{notification.name}} {{notification.message}} {{notification.created_at}}</h4>
                                        </router-link>
                                        <a href="javascript:void(0)" class="dishbtn" @click="dismissNotification(notification, 1)">
                                            Dismiss
                                        </a>
                                    </li>
                                    <template v-if="soNotifications && soNotifications.length">
                                        <li v-for="(notification, index) in soNotifications" :key="'so_notification_key_' + index">
                                            <router-link :to="{ name: 'orderShow', params: { id: notification.order_id }}">
                                                <h4>{{notification.title}} {{notification.body}} {{notification.created_at}}</h4>
                                            </router-link>
                                            <a href="javascript:void(0)" class="dishbtn" @click="dismissNotification(notification, 2)">
                                                Dismiss
                                            </a>
                                        </li>
                                    </template>
                                    <template v-if="poNotifications && poNotifications.length">
                                        <li v-for="(notification, index) in poNotifications" :key="'po_notification_key_' + index">
                                            <router-link :to="{ name: 'purchaseOrderShow', params: { id: notification.order_id }}">
                                                <h4>{{notification.title}} {{notification.body}} {{notification.created_at}}</h4>
                                            </router-link>
                                            <a href="javascript:void(0)" class="dishbtn" @click="dismissNotification(notification, 3)">
                                                Dismiss
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                      </div>
                    </li>

                    <!--<li class="nav-item dropdown language-list">
                        <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        <img  src="images/flags/us.svg" alt="Header Language" height="20"
                                       >
                        </a>
                        <div class="dropdown-menu">
                            <div class="country-con">
                                <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" data-lang="en"
                                    title="English">
                                    <img src="images/flags/us.svg" alt="user-image" class="me-2 rounded" height="18">
                                    <span class="align-middle">English</span>
                                </a>

                                <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="sp"
                                    title="Spanish">
                                    <img src="images/flags/spain.svg" alt="user-image" class="me-2 rounded" height="18">
                                    <span class="align-middle">Española</span>
                                </a>

                                <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="gr"
                                    title="German">
                                    <img src="images/flags/germany.svg" alt="user-image" class="me-2 rounded"
                                        height="18"> <span class="align-middle">Deutsche</span>
                                </a>

                                <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="it"
                                    title="Italian">
                                    <img src="images/flags/italy.svg" alt="user-image" class="me-2 rounded" height="18">
                                    <span class="align-middle">Italiana</span>
                                </a>

                                <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="ru"
                                    title="Russian">
                                    <img src="images/flags/russia.svg" alt="user-image" class="me-2 rounded" height="18">
                                    <span class="align-middle">русский</span>
                                </a>

                                <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="ch"
                                    title="Chinese">
                                    <img src="images/flags/china.svg" alt="user-image" class="me-2 rounded" height="18">
                                    <span class="align-middle">中国人</span>
                                </a>

                                <a href="javascript:void(0);" class="dropdown-item notify-item language" data-lang="fr"
                                    title="French">
                                    <img src="images/flags/french.svg" alt="user-image" class="me-2 rounded" height="18">
                                    <span class="align-middle">français</span>
                                </a>
                            </div>
                        </div>
                    </li>-->
                    <!-- Dropdown -->
                    <li class="nav-item btn-group user-container">
                      <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                      <span class="user-avatar"></span> <div class="user-name" v-if="user">{{user.name}} <span class="edit-profile">Edit Profile</span></div>
                      </a>
                      <div class="dropdown-menu">
                      <router-link class="dropdown-item" :to="{ name: 'profile'}">
                        <i class="fas fa-user-circle"></i> Profile</router-link>
                        <a  href="#" @click="logout"><i class="fas fa-sign-out-alt"></i> Logout</a>
                      </div>
                    </li>
                  </ul>
                </nav>
                </div>
            </div>
        </nav>
    </header>


    <!-- /HEADER-->
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "Header",
    props: {
        auth: Object,
        notifications: Array,
        notification_count: Number,
        soNotifications: Array,
        poNotifications: Array,
    },
    beforeMount() {
        let auth = localStorage.getItem('auth');
        if(auth) {
            let user = JSON.parse(auth);
            this.user = user ? user.user : null
        }
    },
    data() {
        return {
            user: null
        }
    },
    methods: {
        logout() {
            localStorage.removeItem("auth");
            localStorage.removeItem("token");
            this.$emit('logout');
            this.$router.replace( '/login');

        },
        sidebarClicked(){
             $('#sidebar').toggleClass('active');
        },
        dismissAllNotification() {
            this.$emit('onDismissAllNotification');
        },
        dismissNotification(item, type) {
            this.$emit('onDismissNotification', {item: item, type: type});
        },
        getPageHeaderTitle() {
            if(this.currentRouteName == 'dashboard') {
                return 'Dashboard';
            } else if(this.currentRouteName == 'quotations') {
                return 'Quotations';
            } else if(this.currentRouteName == 'addQuotePage') {
                return 'Create New RFQ';
            } else if(this.currentRouteName == 'PriceCalculationPage') {
                return 'Calculator';
            } else if(this.currentRouteName == 'SendToCustomerPage') {
                return 'Quote to Customer';
            } else if(this.currentRouteName == 'ViewCustomerQuote') {
                return 'Quote to Customer';
            } else if(this.currentRouteName == 'draft') {
                return 'Quotation Drafts';
            } else if(this.currentRouteName == 'viewQuote') {
                return 'Quotation Detail';
            } else if(this.currentRouteName == 'orders') {
                return 'Sales Orders';
            } else if(this.currentRouteName == 'draft.orders') {
                return 'Order Drafts';
            } else if(this.currentRouteName == 'orderShow') {
                return 'Order Detail';
            } else if(this.currentRouteName == 'selectCustomer') {
                return 'Create New Order - Select Customer';
            } else if(this.currentRouteName == 'selectQuotes') {
                return 'Create New Order - Select Quote';
            } else if(this.currentRouteName == 'selectProducts') {
                return 'Create New Order - Select Products';
            } else if(this.currentRouteName == 'provideOtherInfo') {
                return 'Create New Order - Other Info';
            } else if(this.currentRouteName == 'purchaseOrders') {
                return 'Purchase Orders';
            } else if(this.currentRouteName == 'draft.purchaseOrders') {
                return 'Purchase Order Drafts';
            } else if(this.currentRouteName == 'purchaseOrderShow') {
                return 'Purchase Order Detail';
            } else if(this.currentRouteName == 'purchaseSelectProducts') {
                return 'Purchase Order - Select Products';
            } else if(this.currentRouteName == 'purchaseSelectVendor') {
                return 'Purchase Order - Select Vendor';
            } else if(this.currentRouteName == 'purchaseProvideOtherInfo') {
                return 'Purchase Order - Other Info';
            } else if(this.currentRouteName == 'viewProducts') {
                return 'Products';
            } else if(this.currentRouteName == 'productsDetails') {
                return 'Product Detail';
            } else if(this.currentRouteName == 'addProducts') {
                return 'Create New Product';
            } else if(this.currentRouteName == 'editProducts') {
                return 'Edit Product';
            } else if(this.currentRouteName == 'viewVendors') {
                return 'Vendors';
            } else if(this.currentRouteName == 'vendorDetails') {
                return 'Vendor Detail';
            } else if(this.currentRouteName == 'addVendor') {
                return 'Create New Vendor';
            } else if(this.currentRouteName == 'editVendor') {
                return 'Edit Vendor';
            } else if(this.currentRouteName == 'viewCustomers') {
                return 'Customers';
            } else if(this.currentRouteName == 'customerDetails') {
                return 'Customer Detail';
            } else if(this.currentRouteName == 'addCustomer') {
                return 'Create New Customer';
            } else if(this.currentRouteName == 'editCustomer') {
                return 'Edit Customer';
            } else if(this.currentRouteName == 'viewTasks') {
                return 'Tasks';
            } else if(this.currentRouteName == 'taskDetails') {
                return 'Task Detail';
            } else if(this.currentRouteName == 'addTask') {
                return 'Create New Task';
            } else if(this.currentRouteName == 'taskEdit') {
                return 'Edit Task';
            } else if(this.currentRouteName == 'taskView') {
                return 'Task Details';
            } else if(this.currentRouteName == 'reminders') {
                return 'Reminders';
            } else if(this.currentRouteName == 'tasks') {
                return 'Order Tasks';
            } else if(this.currentRouteName == 'viewUsers') {
                return 'Users';
            } else if(this.currentRouteName == 'userRoles') {
                return 'User Roles';
            } else if(this.currentRouteName == 'viewBagList') {
                return 'Vendor Bags';
            } else if(this.currentRouteName == 'quotaionStatus') {
                return 'Quotation Status';
            } else if(this.currentRouteName == 'salesRep') {
                return 'Sales Rep List';
            } else if(this.currentRouteName == 'viewTasksPriority') {
                return 'Task Priority';
            } else if(this.currentRouteName == 'globalSetting') {
                return 'Global Settings';
            } else if(this.currentRouteName == 'profile') {
                return 'My Profile';
            } else if(this.currentRouteName == 'taskWorkflows') {
                return 'Task Workflows';
            } else if(this.currentRouteName == 'notification_settings') {
                return 'Notification Settings';
            } 
            else if(this.currentRouteName == 'reportsSO') {
                return 'Order Reports';
            }
            else if(this.currentRouteName == 'reportsPO') {
                return 'Purchase Reports';
            }
            else if(this.currentRouteName == 'purchaseOrderShowShipment') {
                return 'Shipment Details';
            }
            {
                return 'Dashboard';
            }
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
}
</script>

<style scoped>

</style>
